export default __webpack_public_path__ + "static/media/logo-AppMosphera-r.701748e9.png";